import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { WHATSAPP_LINK } from "@/data/content";

export function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Discuter avec Koranex sur WhatsApp"
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 px-4 py-3 rounded-full bg-[#1d4ed8] hover:bg-blue-600 border border-[#38bdf8]/40 text-white shadow-2xl shadow-blue-950 transition-all hover:-translate-y-0.5"
    >
      <span className="absolute inset-0 rounded-full border-2 border-[#38bdf8] kx-ping-ring pointer-events-none" aria-hidden="true" />
      <WhatsAppIcon className="w-5 h-5" />
      <span className="hidden sm:inline text-xs font-mono-x font-bold uppercase tracking-wider">WhatsApp</span>
    </a>
  );
}
